export const masker = (mask, value, RULE = /\D/g, TOKEN_CHAR = '#') => {
  if (!value) return ''

  const inputLeft = String(value).replace(RULE, '').split('')

  return mask.split('')
    .map(char => char === TOKEN_CHAR ? inputLeft.shift() : char)
    .join('')
}
